<template>
  <div class="wrapper" style="height:400px;width:100%;">
    <div class="row">
      <div class="col-md">
        <div role="toolbar" class="btn-toolbar mb-2">
          <button @click="save()" class="btn btn-secondary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          <div class="input-group ml-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <input type="checkbox" v-model="config['if.proxy.createordernumber']" true-value="1" false-value="0">
              </div>
            </div>
            <input type="text" class="form-control" value="Aktiviert" disabled>
          </div>
        </div>
        <AceEditor ref="editor" :editorId='"docNumEditor"' :lang="'javascript'" :content="script"/>
      </div>
      <div class="col-md">
        <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/ordernumbers.html'">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import rules from '@/modules/rules.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'RuleDocNumber',
  components: {
    AceEditor
  },
  data() {
    return {
      baseurl: config.baseUrl,
      script: "",
      config: {},
      needs: ["if.proxy.createordernumber"],
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      if (data) {
        self.config = data;
      }
    });
    rules.load('orderNumbers',function(data) {
      self.script = data.script;
    })
  },
  methods: {
    save: function() {
      this.script = this.$refs.editor.getContent();

      rules.save({ruleId:'orderNumbers',script:this.script},function() {
        self.$bvToast.toast('Dokumentennummer regel gespeichert.',{title: 'Gespeichert', variant: "success"});
      })
      var self = this;
      config.savecfg(this.config,this,function() {
        console.log('done');
        self.$bvToast.toast('Aktivierung gespeichert.',{title: 'Gespeichert', variant: "success"});
      })
    }
  }
}
</script>
